import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/MarketingLayout';

export default function NotFound() {
  return <MarketingLayout eyebrow="OUT OF BOUNDS" title="This page took a provisional." intro="The link may be old, mistyped or hiding in the rough. Fairplay is still exactly where you left it.">
    <aside>
      <h2>Take the sensible drop.</h2>
      <p>Head back to the clubhouse and continue from there.</p>
      <Link to="/">Return to Fairplay →</Link>
    </aside>
  </MarketingLayout>;
}
